import { Center, FlexProps, HStack, Spinner, Text } from "@chakra-ui/react";

export const ListSpinner = ({ ...rest }: Omit<FlexProps, "children">): React.ReactElement => (
  <Center p={2} {...rest} data-testid="list-spinner">
    <HStack spacing={2}>
      <Spinner />
      <Text color="gray.500" fontSize="sm">
        Chargement… veuillez patienter
      </Text>
    </HStack>
  </Center>
);
